import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_REST_URL, // Reemplaza esto con la URL de tu API
});

// Agrega un interceptor de solicitud a Axios
api.interceptors.request.use(
  (config) => {
    // Recupera el token del sessionStorage
    const token = sessionStorage.getItem('token');
    // Agrega el token al encabezado de autorización de la solicitud
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isRefreshing = false;
let refreshSubscribers = [];

function subscribeTokenRefresh(callback) {
  refreshSubscribers.push(callback);
}

function onRefreshed(newToken) {
  refreshSubscribers.forEach((callback) => callback(newToken));
  refreshSubscribers = [];
}

async function refreshAccessToken() {
  const refreshToken = sessionStorage.getItem('refreshToken');
  sessionStorage.removeItem('token');

  const response = await api.post(
    `${process.env.REACT_APP_REST_URL}refreshToken.php`,
    { refreshToken: refreshToken }
  );

  const newAccessToken = response.data.token;
  sessionStorage.setItem('token', newAccessToken);

  return newAccessToken;
}

// Agrega un interceptor de respuesta a Axios
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) {
      return Promise.reject(error);
    }

    const originalRequest = error.config;

    if (error.response.status === 403) {
      window.location.href = '/403.html';
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = sessionStorage.getItem('refreshToken');
      if (!refreshToken) {
        sessionStorage.clear();
        window.location.href = '/login';
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve) => {
          subscribeTokenRefresh((newToken) => {
            originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
            resolve(api(originalRequest));
          });
        });
      }

      isRefreshing = true;

      try {
        const newToken = await refreshAccessToken();
        isRefreshing = false;
        onRefreshed(newToken);

        originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
        return api(originalRequest);
      } catch (refreshError) {
        isRefreshing = false;
        sessionStorage.clear();
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);


export default api;
